if (!customElements.get("price-range")) {
  class t extends HTMLElement {
    constructor() {
      super(), window.initLazyScript(this, this.init.bind(this));
    }
    init() {
      (this.minNumberInput = document.getElementById("price-range-number-min")),
        (this.maxNumberInput = document.getElementById(
          "price-range-number-max"
        )),
        (this.minSliderInput = document.getElementById(
          "price-range-slider-min"
        )),
        (this.maxSliderInput = document.getElementById(
          "price-range-slider-max"
        )),
        (this.minValue = Number(this.minNumberInput.min)),
        (this.maxValue = Number(this.maxNumberInput.max)),
        (this.timeout = null),
        this.addEventListener("input", this.handleInput.bind(this));
    }
    handleInput(t) {
      void 0 !== t.detail
        ? (clearTimeout(this.timeout),
          (this.timeout = setTimeout(() => {
            this.updateSliderInputs(t), this.updateNumberInputs();
          }, 500)))
        : (this.updateSliderInputs(t), this.updateNumberInputs());
    }
    updateNumberInputs() {
      (this.minNumberInput.value =
        this.minSliderInput.value !== this.minNumberInput.min
          ? this.minSliderInput.value
          : null),
        (this.maxNumberInput.value =
          this.maxSliderInput.value !== this.maxNumberInput.max
            ? this.maxSliderInput.value
            : null);
    }
    updateSliderInputs(t) {
      let i = parseInt(this.minNumberInput.value, 10),
        e = parseInt(this.maxNumberInput.value, 10);
      i > e - 10 &&
        (t.target === this.minNumberInput
          ? ((this.maxSliderInput.value = i + 10),
            e === this.maxValue &&
              (this.minSliderInput.value = this.maxValue - 10))
          : (this.minSliderInput.value = e - 10)),
        e < i + 10 &&
          (t.target === this.maxNumberInput
            ? ((this.minSliderInput.value = e - 10),
              i === this.minValue && (this.maxSliderInput.value = 10))
            : (this.maxSliderInput.value = i + 10)),
        t.target === this.minNumberInput &&
          (this.minSliderInput.value = i || Number(this.minNumberInput.min)),
        t.target === this.maxNumberInput &&
          (this.maxSliderInput.value = e || Number(this.maxNumberInput.max));
    }
  }
  customElements.define("price-range", t);
}
